import { c as _c } from "react/compiler-runtime";
import { UtilsTypes } from "@stellar/utils";
import { useAppDispatch } from "@store/store-helper";
import { resetTableState, setTableType } from "@store/table/table-slice";
import { TableType } from "@utils/track-event/track-event-list";
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

/** Context in which the projects table is being displayed. Used by the bulk actions logic */

/** Handles computing the table context type and setting it in the redux store */
export function useProjectsTableContext(t0) {
  const $ = _c(8);
  const {
    projectArchivingState,
    groupId
  } = t0;
  const dispatch = useAppDispatch();
  const {
    pathname
  } = useLocation();
  let t1;
  bb0: {
    if (groupId) {
      t1 = "group projects";
      break bb0;
    }
    if (projectArchivingState === UtilsTypes.ProjectArchivingState.active) {
      t1 = "active projects";
      break bb0;
    }
    t1 = "archived projects";
  }
  const contextType = t1;
  let t2;
  let t3;
  if ($[0] !== contextType || $[1] !== dispatch) {
    t2 = () => {
      bb10: switch (contextType) {
        case "active projects":
          {
            dispatch(setTableType(TableType.activeProjects));
            break bb10;
          }
        case "archived projects":
          {
            dispatch(setTableType(TableType.archiveProjects));
            break bb10;
          }
        case "group projects":
          {
            dispatch(setTableType(TableType.groupProjects));
          }
      }
    };
    t3 = [contextType, dispatch];
    $[0] = contextType;
    $[1] = dispatch;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[4] !== dispatch || $[5] !== pathname) {
    t4 = () => {
      if (!pathname.includes("projects")) {
        dispatch(resetTableState());
      }
    };
    t5 = [pathname, dispatch];
    $[4] = dispatch;
    $[5] = pathname;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  return contextType;
}